<template>
  <div
    v-tooltip="$t(tooltip)"
    class="team-icons"
  >
    <img
      v-for="url in images"
      :key="url"
      :src="getImageFromProxy(url, '50:50')"
      alt="side image"
      class="team-icons__item"
    >
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ team: string }>();
const terroristsImage = 'https://csmarketcap.com/icons/sides/terrorist.png';
const ctImage = 'https://csmarketcap.com/icons/sides/counter-terrorist.png';

const images = computed(() => {
  if (props.team.toLowerCase() === 'terrorists') {
    return [terroristsImage];
  }
  if (props.team.toLowerCase() === 'both') {
    return [ctImage, terroristsImage];
  }
  return [ctImage];
});

const tooltip = computed(() => {
  if (props.team.toLowerCase() === 'terrorists') {
    return 'weapon_used_t';
  }
  if (props.team.toLowerCase() === 'both') {
    return 'weapon_used_ct_and_t';
  }
  return 'weapon_used_ct';
});
</script>

<style lang="scss" scoped>
.team-icons {
  display: flex;
  justify-content: center;
  align-items: center;

  &__item {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: contain;
    position: relative;
    z-index: 1;

    &:not(:first-child) {
      position: relative;
      left: -16px;
      z-index: 0;
    }
  }

}
</style>
